import React from "react";
import PropTypes from "prop-types";
import IconButton from "components/icon-button";
import styles from "./styles/menu-icon.css.js";
import withStyles from "components/with-styles";
import Icon from "components/icon";

const MenuIcon = ({ onClick, classes }) => (
  <div className={classes.dashboard_menu_drawer_icon}>
    <IconButton onClick={onClick}>
      <Icon name="chevron-left" />
    </IconButton>
  </div>
);

MenuIcon.propTypes = {
  /**
   * Handler que se llama cuando se hace click en el icono
   **/
  onClick: PropTypes.func,
};

export default withStyles(styles)(MenuIcon);
